"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions2 = require("egov-ui-kit/redux/form/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "roomDetails",
  fields: {
    bedRoom: {
      id: "bedRoom",
      jsonPath: "Properties[0].propertyDetails.roomDetails.bedRoom",
      type: "textfield",
      floatingLabelText: "Bed Room",
      localePrefix: true,
      labelsFromLocalisation: false,
      hintText: "Bed Room",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      formName: "roomDetails",
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.bedRoom", field.value));
      }
    },
    hall: {
      id: "acre",
      jsonPath: "Properties[0].propertyDetails.roomDetails.hall",
      type: "textfield",
      floatingLabelText: "Hall",
      hintText: "Hall",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.hall", field.value));
      }
    },

    livingDining: {
      id: "livingDining",
      jsonPath: "Properties[0].propertyDetails.roomDetails.livingDining",
      type: "textfield",
      floatingLabelText: "Living Dining",
      hintText: "Living Dining",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.livingDining", field.value));
      }
    },

    conference: {
      id: "conference",
      jsonPath: "Properties[0].propertyDetails.roomDetails.conference",
      type: "textfield",
      floatingLabelText: "Conference",
      hintText: "Conference",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.conference", field.value));
      }
    },

    covered: {
      id: "covered",
      jsonPath: "Properties[0].propertyDetails.roomDetails.covered",
      type: "textfield",
      floatingLabelText: "Covered",
      hintText: "Covered",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.covered", field.value));
      }
    },
    thakurGhar: {
      id: "thakurGhar",
      jsonPath: "Properties[0].propertyDetails.roomDetails.thakurGhar",
      type: "textfield",
      floatingLabelText: "Thakur Ghar",
      hintText: "Thakur Ghar",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.thakurGhar", field.value));
      }
    },
    bathRoom: {
      id: "bathRoom",
      jsonPath: "Properties[0].propertyDetails.roomDetails.bathRoom",
      type: "textfield",
      floatingLabelText: "Bathroom",
      hintText: "Bathroom",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.bathRoom", field.value));
      }
    },
    healthClub: {
      id: "healthClub",
      jsonPath: "Properties[0].propertyDetails.roomDetails.healthClub",
      type: "textfield",
      floatingLabelText: "Health Club",
      hintText: "Health Club",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.healthClub", field.value));
      }
    },
    classRoom: {
      id: "classRoom",
      jsonPath: "Properties[0].propertyDetails.roomDetails.classRoom",
      type: "textfield",
      floatingLabelText: "Classroom",
      localePrefix: true,
      labelsFromLocalisation: false,
      hintText: "Classroom",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      formName: "roomDetails",
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.classRoom", field.value));
      }
    },
    verandah: {
      id: "verandah",
      jsonPath: "Properties[0].propertyDetails.roomDetails.verandah",
      type: "textfield",
      floatingLabelText: "Verandah",
      hintText: "Verandah",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.verandah", field.value));
      }
    },

    mezzanine: {
      id: "mezzanine",
      jsonPath: "Properties[0].propertyDetails.roomDetails.mezzanine",
      type: "textfield",
      floatingLabelText: "Mezzanine",
      hintText: "Mezzanine",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref11) {
        var formKey = _ref11.formKey,
            field = _ref11.field,
            dispatch = _ref11.dispatch,
            state = _ref11.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.mezzanine", field.value));
      }
    },

    kitchen: {
      id: "kitchen",
      jsonPath: "Properties[0].propertyDetails.roomDetails.kitchen",
      type: "textfield",
      floatingLabelText: "Kitchen",
      hintText: "Kitchen",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref12) {
        var formKey = _ref12.formKey,
            field = _ref12.field,
            dispatch = _ref12.dispatch,
            state = _ref12.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.kitchen", field.value));
      }
    },

    garrage: {
      id: "garrage",
      jsonPath: "Properties[0].propertyDetails.roomDetails.garrage",
      type: "textfield",
      floatingLabelText: "Garage",
      hintText: "Garage",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref13) {
        var formKey = _ref13.formKey,
            field = _ref13.field,
            dispatch = _ref13.dispatch,
            state = _ref13.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.garrage", field.value));
      }
    },
    stairCase: {
      id: "stairCase",
      jsonPath: "Properties[0].propertyDetails.roomDetails.stairCase",
      type: "textfield",
      floatingLabelText: "Stair Case",
      hintText: "stair Case",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref14) {
        var formKey = _ref14.formKey,
            field = _ref14.field,
            dispatch = _ref14.dispatch,
            state = _ref14.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.stairCase", field.value));
      }
    },
    office: {
      id: "office",
      jsonPath: "Properties[0].propertyDetails.roomDetails.office",
      type: "textfield",
      floatingLabelText: "Office",
      hintText: "Office",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref15) {
        var formKey = _ref15.formKey,
            field = _ref15.field,
            dispatch = _ref15.dispatch,
            state = _ref15.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.office", field.value));
      }
    },
    study: {
      id: "study",
      jsonPath: "Properties[0].propertyDetails.roomDetails.study",
      type: "textfield",
      floatingLabelText: "Study",
      hintText: "Study",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref16) {
        var formKey = _ref16.formKey,
            field = _ref16.field,
            dispatch = _ref16.dispatch,
            state = _ref16.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.study", field.value));
      }
    },
    shed: {
      id: "shed",
      jsonPath: "Properties[0].propertyDetails.roomDetails.shed",
      type: "textfield",
      floatingLabelText: "Shed",
      hintText: "Shed",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref17) {
        var formKey = _ref17.formKey,
            field = _ref17.field,
            dispatch = _ref17.dispatch,
            state = _ref17.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.shed", field.value));
      }
    },
    terrace: {
      id: "terrace",
      jsonPath: "Properties[0].propertyDetails.roomDetails.terrace",
      type: "textfield",
      floatingLabelText: "Terrace",
      hintText: "Terrace",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref18) {
        var formKey = _ref18.formKey,
            field = _ref18.field,
            dispatch = _ref18.dispatch,
            state = _ref18.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.terrace", field.value));
      }
    },
    shop: {
      id: "shop",
      jsonPath: "Properties[0].propertyDetails.roomDetails.shop",
      type: "textfield",
      floatingLabelText: "Shop",
      hintText: "Shop",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref19) {
        var formKey = _ref19.formKey,
            field = _ref19.field,
            dispatch = _ref19.dispatch,
            state = _ref19.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.shop", field.value));
      }
    },
    store: {
      id: "store",
      jsonPath: "Properties[0].propertyDetails.roomDetails.store",
      type: "textfield",
      floatingLabelText: "Store",
      hintText: "Store",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref20) {
        var formKey = _ref20.formKey,
            field = _ref20.field,
            dispatch = _ref20.dispatch,
            state = _ref20.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.store", field.value));
      }
    },
    wallShop: {
      id: "wallShop",
      jsonPath: "Properties[0].propertyDetails.roomDetails.wallShop",
      type: "textfield",
      floatingLabelText: "Wall Shop",
      hintText: "Wall Shop",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref21) {
        var formKey = _ref21.formKey,
            field = _ref21.field,
            dispatch = _ref21.dispatch,
            state = _ref21.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.wallShop", field.value));
      }
    },
    swimingPool: {
      id: "swimingPool",
      jsonPath: "Properties[0].propertyDetails.roomDetails.swimingPool",
      type: "textfield",
      floatingLabelText: "Swimming Pool",
      hintText: "Swimming Pool",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref22) {
        var formKey = _ref22.formKey,
            field = _ref22.field,
            dispatch = _ref22.dispatch,
            state = _ref22.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.swimingPool", field.value));
      }
    },
    others: {
      id: "others",
      jsonPath: "Properties[0].propertyDetails.roomDetails.others",
      type: "textarea",
      floatingLabelText: "Others",
      hintText: "Others",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_ADDRESS_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref23) {
        var formKey = _ref23.formKey,
            field = _ref23.field,
            dispatch = _ref23.dispatch,
            state = _ref23.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.others", field.value));
      }
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var urlParams = getParameterByName("isInspection");
    if (urlParams == "yes") {
      var state = store.getState();
      var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties");

      if (data && data.length > 0) {
        var roomDetails = data[0].propertyDetails.roomDetails;

        if (roomDetails && Object.keys(roomDetails).length > 0) {
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "bedRoom", "value", roomDetails.bedRoom.toString()));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "hall", "value", roomDetails.hall.toString()));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "livingDining", "value", roomDetails.livingDining ? roomDetails.livingDining.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "conference", "value", roomDetails.conference ? roomDetails.conference.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "covered", "value", roomDetails.covered ? roomDetails.covered.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "thakurGhar", "value", roomDetails.thakurGhar ? roomDetails.thakurGhar.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "bathRoom", "value", roomDetails.bathRoom ? roomDetails.bathRoom.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "healthClub", "value", roomDetails.healthClub ? roomDetails.healthClub.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "classRoom", "value", roomDetails.classRoom ? roomDetails.classRoom.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "verandah", "value", roomDetails.verandah ? roomDetails.verandah.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "mezzanine", "value", roomDetails.mezzanine ? roomDetails.mezzanine.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "kitchen", "value", roomDetails.kitchen ? roomDetails.kitchen.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "garrage", "value", roomDetails.garrage ? roomDetails.garrage.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "stairCase", "value", roomDetails.stairCase ? roomDetails.stairCase.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "office", "value", roomDetails.office ? roomDetails.office.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "study", "value", roomDetails.study ? roomDetails.study.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "shed", "value", roomDetails.shed ? roomDetails.shed.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "terrace", "value", roomDetails.terrace ? roomDetails.terrace.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "shop", "value", roomDetails.shop ? roomDetails.shop.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "store", "value", roomDetails.store ? roomDetails.store.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "wallShop", "value", roomDetails.wallShop ? roomDetails.wallShop.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "swimingPool", "value", roomDetails.swimingPool ? roomDetails.swimingPool.toString() : ""));
          dispatch((0, _actions2.setFieldProperty)("roomDetails", "others", "value", roomDetails.others ? roomDetails.others.toString() : ""));

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.bedRoom", roomDetails.bedRoom ? roomDetails.bedRoom.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.hall", roomDetails.hall ? roomDetails.hall.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.livingDining", roomDetails.livingDining ? roomDetails.livingDining.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.conference", roomDetails.conference ? roomDetails.conference.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.covered", roomDetails.covered ? roomDetails.covered.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.thakurGhar", roomDetails.thakurGhar ? roomDetails.thakurGhar.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.bathRoom", roomDetails.bathRoom ? roomDetails.bathRoom.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.healthClub", roomDetails.healthClub ? roomDetails.healthClub.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.classRoom", roomDetails.classRoom ? roomDetails.classRoom.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.verandah", roomDetails.verandah ? roomDetails.verandah.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.mezzanine", roomDetails.mezzanine ? roomDetails.mezzanine.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.kitchen", roomDetails.kitchen ? roomDetails.kitchen.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.garrage", roomDetails.garrage ? roomDetails.garrage.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.stairCase", roomDetails.stairCase ? roomDetails.stairCase.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.office", roomDetails.office ? roomDetails.office.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.study", roomDetails.study ? roomDetails.study.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.shed", roomDetails.shed ? roomDetails.shed.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.terrace", roomDetails.terrace ? roomDetails.terrace.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.shop", roomDetails.shop ? roomDetails.shop.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.store", roomDetails.store ? roomDetails.store.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.wallShop", roomDetails.wallShop ? roomDetails.wallShop.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.swimingPool", roomDetails.rebateAmount ? roomDetails.rebateAmount.toString() : ""));
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.others", roomDetails.others ? roomDetails.others.toString() : ""));
        }
      }
    }
    return action;
  },
  beforeInitForm: function beforeInitForm(action, store) {
    return action;
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/roomDetails.js
// module id = 1894
// module chunks = 1137